import { useLang } from '../../../i18n';
import Card from '../../../components/Card';
import type { Order } from '../../../types';

interface Props { order: Order }

export default function OrderOverview({ order }: Props) {
  const { t } = useLang();
  const fmt = (s: string | null) => (s ? new Date(s).toLocaleDateString() : '—');
  return (
    <div className="order-overview">
      <Card padding="md">
        <h3 className="order-overview__title">{t('order.description')}</h3>
        <p className="order-overview__text">{order.description_md || '—'}</p>
      </Card>
      <Card padding="md">
        <dl className="order-overview__grid">
          <div className="order-overview__row">
            <dt className="order-overview__label">{t('order.customer')}</dt>
            <dd className="order-overview__value">{order.customer || '—'}</dd>
          </div>
          <div className="order-overview__row">
            <dt className="order-overview__label">{t('order.organization')}</dt>
            <dd className="order-overview__value">{order.organization || '—'}</dd>
          </div>
          <div className="order-overview__row">
            <dt className="order-overview__label">{t('order.start_at')}</dt>
            <dd className="order-overview__value">{fmt(order.start_at)}</dd>
          </div>
          <div className="order-overview__row">
            <dt className="order-overview__label">{t('order.due_at')}</dt>
            <dd className="order-overview__value">{fmt(order.due_at)}</dd>
          </div>
        </dl>
      </Card>
      <Card padding="md">
        <h3 className="order-overview__title">{t('order.milestones')}</h3>
        <ul className="order-overview__milestones">
          {(order.stages || []).map((s) => (
            <li key={s.public_id} className="order-overview__milestone">
              <span className="order-overview__milestone-dot" data-status={s.status} aria-hidden="true" />
              <span className="order-overview__milestone-title">{s.title}</span>
            </li>
          ))}
          {(!order.stages || order.stages.length === 0) ? (
            <li className="order-overview__milestone-empty">—</li>
          ) : null}
        </ul>
      </Card>
    </div>
  );
}
